import React, { useState } from 'react';
import { X, Upload, FileText, CheckCircle } from 'lucide-react';
import { MessageModal } from './MessageModal';
interface SourceOfFundsModalProps {
  isOpen: boolean;
  onClose: () => void;
}
export function SourceOfFundsModal({
  isOpen,
  onClose
}: SourceOfFundsModalProps) {
  const [uploadedFiles, setUploadedFiles] = useState<string[]>([]);
  const [isSuccessModalOpen, setIsSuccessModalOpen] = useState(false);
  const [formData, setFormData] = useState({
    sourceType: '',
    amount: '',
    description: ''
  });
  if (!isOpen) return null;
  const handleFileUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = e.target.files;
    if (files) {
      const fileNames = Array.from(files).map(f => f.name);
      setUploadedFiles([...uploadedFiles, ...fileNames]);
    }
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsSuccessModalOpen(true);
    setTimeout(() => {
      onClose();
      setUploadedFiles([]);
      setFormData({
        sourceType: '',
        amount: '',
        description: ''
      });
    }, 2000);
  };
  return <>
      <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4" data-id="element-829">
        <div className="bg-white border border-gray-300 max-w-2xl w-full shadow-lg max-h-[90vh] overflow-y-auto" data-id="element-830">
          <div className="flex justify-between items-center p-6 border-b border-gray-200 sticky top-0 bg-white" data-id="element-831">
            <h3 className="font-bold text-lg flex items-center gap-2" data-id="element-832">
              <FileText className="w-5 h-5" data-id="element-833" />
              Source of Funds Declaration
            </h3>
            <button onClick={onClose} className="text-gray-400 hover:text-gray-600" data-id="element-834">
              <X className="w-5 h-5" data-id="element-835" />
            </button>
          </div>

          <form onSubmit={handleSubmit} className="p-6 space-y-6" data-id="element-836">
            <div className="bg-blue-50 border border-blue-200 p-4" data-id="element-837">
              <h4 className="font-bold text-sm mb-2" data-id="element-838">
                FEMA Compliance Requirement
              </h4>
              <p className="text-sm text-gray-700" data-id="element-839">
                As per FEMA regulations, NRI buyers must declare the source of
                funds for property purchases in India. This helps ensure
                compliance with foreign exchange regulations.
              </p>
            </div>

            <div data-id="element-840">
              <label className="block text-sm font-bold text-gray-700 mb-2" data-id="element-841">
                Source of Funds *
              </label>
              <select required value={formData.sourceType} onChange={e => setFormData({
              ...formData,
              sourceType: e.target.value
            })} className="w-full p-2 border border-gray-300 bg-gray-50 focus:outline-none focus:border-gray-500" data-id="element-842">
                <option value="" data-id="element-843">Select Source</option>
                <option value="nre" data-id="element-844">NRE Account (Non-Resident External)</option>
                <option value="nro" data-id="element-845">NRO Account (Non-Resident Ordinary)</option>
                <option value="fcnr" data-id="element-846">
                  FCNR Account (Foreign Currency Non-Resident)
                </option>
                <option value="inward-remittance" data-id="element-847">
                  Inward Remittance from Abroad
                </option>
                <option value="savings" data-id="element-848">Savings from Employment Abroad</option>
                <option value="other" data-id="element-849">Other (Please specify)</option>
              </select>
            </div>

            <div data-id="element-850">
              <label className="block text-sm font-bold text-gray-700 mb-2" data-id="element-851">
                Estimated Investment Amount (₹) *
              </label>
              <input type="number" required value={formData.amount} onChange={e => setFormData({
              ...formData,
              amount: e.target.value
            })} placeholder="e.g., 5000000" className="w-full p-2 border border-gray-300 bg-gray-50 focus:outline-none focus:border-gray-500" data-id="element-852" />
            </div>

            <div data-id="element-853">
              <label className="block text-sm font-bold text-gray-700 mb-2" data-id="element-854">
                Additional Details
              </label>
              <textarea value={formData.description} onChange={e => setFormData({
              ...formData,
              description: e.target.value
            })} placeholder="Provide any additional information about the source of funds..." rows={3} className="w-full p-2 border border-gray-300 bg-gray-50 focus:outline-none focus:border-gray-500" data-id="element-855" />
            </div>

            <div data-id="element-856">
              <label className="block text-sm font-bold text-gray-700 mb-2" data-id="element-857">
                Supporting Documents *
              </label>
              <div className="border-2 border-dashed border-gray-300 p-8 bg-gray-50 text-center" data-id="element-858">
                <Upload className="w-8 h-8 mx-auto text-gray-400 mb-3" data-id="element-859" />
                <p className="text-sm font-bold mb-2" data-id="element-860">
                  Upload bank statements or proof
                </p>
                <p className="text-xs text-gray-500 mb-4" data-id="element-861">
                  Bank statements, remittance receipts, or other proof (PDF, max
                  10MB)
                </p>
                <input type="file" multiple accept=".pdf" onChange={handleFileUpload} className="hidden" id="funds-upload" data-id="element-862" />
                <label htmlFor="funds-upload" className="inline-block px-6 py-2 bg-white border border-gray-300 text-sm font-bold cursor-pointer hover:bg-gray-50" data-id="element-863">
                  Choose Files
                </label>
              </div>

              {uploadedFiles.length > 0 && <div className="mt-4 space-y-2" data-id="element-864">
                  {uploadedFiles.map((file, i) => <div key={i} className="flex items-center gap-2 p-2 bg-green-50 border border-green-200" data-id="element-865">
                      <CheckCircle className="w-4 h-4 text-green-600" data-id="element-866" />
                      <span className="text-sm flex-1" data-id="element-867">{file}</span>
                      <button type="button" onClick={() => setUploadedFiles(uploadedFiles.filter((_, idx) => idx !== i))} className="text-xs text-red-600 hover:underline" data-id="element-868">
                        Remove
                      </button>
                    </div>)}
                </div>}
            </div>

            <div className="bg-gray-50 border border-gray-200 p-4" data-id="element-869">
              <label className="flex items-start gap-3" data-id="element-870">
                <input type="checkbox" required className="mt-1 w-4 h-4 accent-[#1f2933]" data-id="element-871" />
                <span className="text-xs text-gray-700" data-id="element-872">
                  I declare that the information provided is true and accurate.
                  I understand that this declaration is required for FEMA
                  compliance and may be verified by relevant authorities.
                </span>
              </label>
            </div>

            <div className="flex justify-end gap-3 pt-4 border-t border-gray-200" data-id="element-873">
              <button type="button" onClick={onClose} className="px-6 py-2 border border-gray-300 text-sm font-bold hover:bg-gray-50" data-id="element-874">
                Cancel
              </button>
              <button type="submit" disabled={uploadedFiles.length === 0} className="px-6 py-2 bg-[#1f2933] text-white text-sm font-bold hover:bg-gray-800 disabled:opacity-50 disabled:cursor-not-allowed" data-id="element-875">
                Submit Declaration
              </button>
            </div>
          </form>
        </div>
      </div>

      <MessageModal isOpen={isSuccessModalOpen} onClose={() => setIsSuccessModalOpen(false)} title="Declaration Submitted" message="Your source of funds declaration has been submitted successfully. This will be reviewed as part of your FEMA compliance verification." type="success" data-id="element-876" />
    </>;
}